import React from 'react';
import {
  FDStack, FDBox,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDashboardWizardNav,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardNav';
import fr from 'facet-rest';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { buildMemberMessagesPageLink } from 'Views/Page/Content/Templates';

const Layout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { householdResource } = useSimpleHousehold();

  const onNextOverrideHref = resource.withRelationship(
    fr.relationships.thread.name,
    (rel) => buildMemberMessagesPageLink(householdResource, rel.link('related').url()),
    () => undefined,
  );

  return (
    <LottieLoadingLayout>
      <TaxDashboardWizardNav
        extraNavRelationshipName={resource.relationship(fr.relationships.exit.name) && fr.relationships.exit.name}
        extraNavLabel={resource.attr('skipLabel')}
        onClickExtraNavOverride={onSubmit}
        onNextOverrideHref={onNextOverrideHref}
      >
        <FDStack direction="column" spacing={2}>

          {resource.withRelationship(
            fr.relationships.lottie.name,
            (rel) => <LottieRel width={'50%'} relationship={rel} />,
            () => <FDBox paddingY={2} />,
          )}
          <FDStack direction="column" spacing={2}>
            <MetaControlField attr={'title'} {...dataAttrs('tax-dashboard-review-kickoff-outro-title')} />
            <MetaControlField attr={'subtitle'} {...dataAttrs('tax-dashboard-review-kickoff-outro-subtitle')} />
            <MetaControlField attr={'outstandingRmdCopy'} {...dataAttrs('tax-dashboard-review-kickoff-rmd-details')} />
            <MetaControlField attr={'body'} {...dataAttrs('tax-dashboard-review-kickoff-outro-body')} />
          </FDStack>

        </FDStack>
      </TaxDashboardWizardNav>
    </LottieLoadingLayout>
  );
};

export default Layout;
